import React, { useEffect, useState, useContext } from 'react';
import { GlobalContext } from '../Contexts/GlobalContext';
import useFetch from './useFetch';
import { loadScript } from '../Util/LoadScript';

export default function useOneSignal(props) {
    const globalContext = useContext(GlobalContext);
    const [sendOneSignalIdResponse, sendOneSignalId] = useFetch();

    useEffect(
        () => {

            const f = async () => {

                if (window.location.href.indexOf('http://localhost') != 0 || true) {
                    loadScript('https://cdn.onesignal.com/sdks/OneSignalSDK.js');



                    if (!globalContext.globalState.oneSignalInitialized) {




                        let waitForScriptToLod = await new Promise((resolve, reject) => {
                            const intervalId = setInterval(() => {

                                if (window.OneSignal) {
                                    clearInterval(intervalId);
                                    resolve();
                                }
                            }, 100);
                        })



                        let oneSignal = window.OneSignal || [];




                        globalContext.dispatchMethod({ type: 'INITIALIZE_ONESIGNAL', value: null, })
                        let appId = window.location.href.indexOf('https://testadmin') == 0 ? 
                        "f14245fa-25e4-4d30-8852-472b9217e2f1" : "728eaf3b-2b7f-4659-ab0a-b93111125279";

                        oneSignal.push(function () {
                            oneSignal.init({
                                appId: appId,
                                welcomeNotification: {
                                    disable: true
                                },
                                promptOptions: {
                                    slidedown: {
                                        enabled: false,
                                        autoPrompt: false,
                                        //timeDelay: 2000000000,
                                        //pageViews: 3333,
                                        /* These prompt options values configure both the HTTP prompt and the HTTP popup. */
                                        /* actionMessage limited to 90 characters */
                                        actionMessage: "Bu da yeni mesaj kendisi.",
                                        /* acceptButtonText limited to 15 characters */
                                        acceptButtonText: "ALLOW",
                                        /* cancelButtonText limited to 15 characters */
                                        cancelButtonText: "NO THANKS",
                                    }
                                }
                            });
                        });
                        oneSignal.showHttpPermissionRequest();

                        //
                        oneSignal.push(function () {
                            // Occurs when the user's subscription changes to a new value.
                            oneSignal.on('subscriptionChange', async function (isSubscribed) {
                                console.log('cagirildi');
                                console.log(isSubscribed);

                                if (isSubscribed) {
                                    console.log('in subs');
                                    let id = await oneSignal.getUserId();
                                    console.log('await: ' + id);
                                    sendOneSignalIdFunc(id);
                                    /*
                                    oneSignal.getUserId().then(
                                        oneSignalUserId => {
                                            console.log('burada geldi:' + oneSignalUserId);
                                            sendOneSignalIdFunc(oneSignalUserId);
                                        }
                                    ).catch(
                                        (err) =>
                                            console.log(err)
                                    )*/
                                }
                                else {
                                    console.log('user not subs');
                                }

                            });


                        });


                    }
                }
            }

            f();

        }, []
    )

    const sendOneSignalIdFunc = (oneSignalUserId) => {
        console.log("one signal user id:" + oneSignalUserId);
        sendOneSignalId(
            {
                url: '/admin/users/upsert-token',
                addTokenHeader: true,
                method: 'POST',
                postData: {
                    "oneSignalUserId": oneSignalUserId,
                    "token": "string",
                    "isActive": true,
                },
            }
        )
    }

    useEffect(
        () => {
            console.log(sendOneSignalIdResponse);
        }, [sendOneSignalIdResponse]
    )
    return sendOneSignalIdFunc;
}

